<template>
  <div>
    <v-layout row wrap>
      <table class="tabla-pagos">
        <tr>
          <th>Importe</th>
          <th>Fecha de Pago</th>
          <th v-if="esMonedaExtranjera">Tipo de Cambio</th>
          <th>Acciones</th>
        </tr>
        <tr v-for="pago in pagos" :key="pago.pk">
          <td>{{ pago.importe | formatAsCurrency }}</td>
          <td>{{ pago.fechaDePago }}</td>
          <td v-if="esMonedaExtranjera">{{ pago.tipoDeCambio | formatAsCurrency }}</td>
          <td>
            <v-btn icon flat small @click="confirmDelete(pago.pk)" class="pa-0 ma-0 mt-1"
              :disabled="!canEdit">
              <v-tooltip bottom>
                <v-icon slot="activator" color="primary">delete</v-icon>
                <span>Eliminar</span>
              </v-tooltip>
            </v-btn>
          </td>
        </tr>
      </table>
    </v-layout>
    <v-layout row wrap pr-5 pl-5 v-if="canEdit">
      <v-flex pr-2 :xs4="esMonedaExtranjera" :xs6="!esMonedaExtranjera">
        <v-currency-field v-model="$v.importe.$model" label="Importe"
          :error-messages="this.getRequiredErrors('importe')"></v-currency-field>
      </v-flex>
      <v-flex :xs4="esMonedaExtranjera" :xs6="!esMonedaExtranjera">
        <DatePickerForm v-model="$v.fechaDePago.$model" label="Fecha de Pago"
          :error-messages="this.getRequiredErrors('fechaDePago')"></DatePickerForm>
      </v-flex>
      <v-flex pl-2 xs4 v-if="esMonedaExtranjera">
        <v-currency-field v-model="$v.tipoDeCambio.$model" label="Tipo de Cambio"
          :error-messages="this.getRequiredErrors('tipoDeCambio')"></v-currency-field>
      </v-flex>
    </v-layout>
    <ConfirmationDialog ref="confirmDelete" :function-yes="borrarPago" title="¿Eliminar pago?"
      text="¿Desea eliminar este pago?"></ConfirmationDialog>
    <v-btn v-if="canEdit" color="primary" @click="submit">Crear</v-btn>
  </div>
</template>
<script>

import DatePickerForm from '../../../common/ui/DatePickerForm'
import { createEntityMixin } from '../../../mixins/createEntityMixin'
import { validationMixin } from 'vuelidate'
import { required, requiredIf } from 'vuelidate/lib/validators'
import ConfirmationDialog from '../../../common/ui/ConfirmationDialog'

export default {
  mixins: [createEntityMixin, validationMixin],

  validations: {
    importe: { required },
    fechaDePago: { required },
    tipoDeCambio: { required: requiredIf(function () { return this.esMonedaExtranjera }) }
  },

  components: {
    DatePickerForm,
    ConfirmationDialog
  },

  filters: {
    formatAsCurrency (importe) {
      const monto = Number(importe).toLocaleString('es', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      return `$ ${monto}`
    }
  },

  props: {
    cuotaId: [Number, String],
    esMonedaExtranjera: Boolean,
    canEdit: Boolean
  },

  data () {
    return {
      pagos: [],
      importe: null,
      fechaDePago: null,
      tipoDeCambio: null,
      pagoId: null
    }
  },

  methods: {
    fetchPagos () {
      const path = `cuota/${this.cuotaId}/pagos`
      this.axios
        .get(path)
        .then(response => { this.pagos = response.data })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    getPayload () {
      const payload = {
        cuota: this.cuotaId,
        importe: this.importe,
        fechaDePago: this.fechaDePago
      }
      if (this.esMonedaExtranjera) {
        payload.tipoDeCambio = this.tipoDeCambio
      }
      return payload
    },
    resetForm () {
      this.$v.$reset()
    },
    postSuccessfulSubmit () {
      this.fetchPagos()
      this.updatedPagos()
    },
    updatedPagos () {
      this.$emit('updatedPagos')
    },
    isValidForm () {
      return !this.$v.$invalid
    },
    confirmDelete (id) {
      this.pagoId = id
      this.$refs.confirmDelete.openDialog()
    },
    borrarPago () {
      const pk = this.pagoId
      const path = `cuota/pago/${pk}/delete`
      this.axios
        .delete(path)
        .then(response => { this.postSuccessfulSubmit() })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
      this.pagoId = null
    }
  },

  computed: {
    createPath () {
      return `cuota/pago/add`
    },
    headers () {
      const headers = [
        { text: 'Importe', value: 'importe' },
        { text: 'Tipo de Cambio', value: 'tipoDeCambio' },
        { text: 'Fecha de Pago', value: 'fechaDePago' }
      ]
      return headers
    }
  },

  created () {
    this.fetchPagos()
  }

}
</script>
<style scoped>
.tabla-pagos {
  width: 100%;
}
.tabla-pagos tr:hover {
  background-color: rgb(200, 200, 200);
}
.tabla-pagos th {
  padding-top: 1em;
  border-bottom: 1px solid #bbb;
}
.tabla-pagos td {
  text-align: center;
  border-bottom: 1px solid #bbb;
}
</style>
